import * as React from "react";
import styled, { css } from "styled-components";
import scaleForGradient from "views/components/sidebar/highlighting/Scale";
const ColorPreviewBase = styled.div`
  height: 25px;
  width: 25px;
  margin-right: 0.4rem;

  border-radius: 4px;
  border: 1px solid rgb(0 126 255 / 24%);
`;
const StaticColorPreview = styled(ColorPreviewBase)(
  ({ color }) => css`
    background-color: ${color};
  `
);
const colorsForGradient = (gradient, count = 5) => scaleForGradient(gradient).colors(count);
export const GradientColorPreview = styled(ColorPreviewBase)(({ $gradient }) => {
  const colors = colorsForGradient($gradient);
  return css`
    border: none;
    background: linear-gradient(
      0deg,
      ${colors.map((color, idx) => `${color} ${idx * (100 / colors.length)}%`).join(", ")}
    );
  `;
});
const ColorPreview = ({ color, onClick = () => {
} }, ref) => {
  if (color.type === "static") {
    return /* @__PURE__ */ React.createElement(
      StaticColorPreview,
      {
        ref,
        "data-testid": "static-color-preview",
        onClick,
        color: color.color
      }
    );
  }
  if (color.type === "gradient") {
    return /* @__PURE__ */ React.createElement(GradientColorPreview, { ref, onClick, $gradient: color.gradient });
  }
  throw new Error(`Invalid highlighting color type: ${color}`);
};
export default React.forwardRef(ColorPreview);
